import React from "react";

import {IMatchesCount} from "./viewer/props";

export class PdfDialogState {
    numPages: number = 0;
    currentPage: number = 0;
    matchesCount: IMatchesCount | null = null;
}

export type PdfDialog_SetStateAction = React.Dispatch<React.SetStateAction<PdfDialogState>>
